
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { EditTagForm } from '@/services/QA/tag/forms/EditTagForm';
import { TagInterface, TagRepositoryInterface } from '@/services/QC-V2/tag/interfaces';

@Component({
  inject: [
    'tagRepositoryV2',
  ],
})
export default class EditTag extends Vue {
  private tag!: TagInterface;
  private readonly tagRepositoryV2!: TagRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<EditTagForm> = new WPXFormValue(EditTagForm);

  public async created(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  private async initialize(): Promise<void> {
    if (!this.$route.params.tagId) {
      this.$errorDialog.show('Tag Id Not Provided');
    }

    this.tag = await this.tagRepositoryV2.getOneById(Number(this.$route.params.tagId));
    this.form.data.label = this.tag.label;
    this.form.data.color = this.tag.color;
  }

  private async editTag(): Promise<void> {
    try {
      await this.tagRepositoryV2.editTag(
        this.tag.id,
        {
          label: this.form.data.label,
          color: this.form.data.color,
        },
      );

      this.$successDialog.show(`Tag '${this.form.data.label}' has been edited`);
      await this.$router.push({ name: 'tags' });
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }
}
